import styled from '@emotion/styled';
import { VideoParagraphT } from 'types/shared/core/Post';
import Config from 'config/Config';
import DownloadIcon from 'assets/icons/download.svg';
import { IconButton } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import interfaceBridge from 'utils/interfaceBridge';
import MobileDetect from 'mobile-detect';
import { useState } from 'react';

type PostContentVideoPropsT = {
  paragraph: VideoParagraphT;
};

const StyledVideoParagraph = styled('div')<{ hasPlayedInIos: boolean }>`
  padding: 0px 0px;
  position: relative;

  & > div.download-button-placer {
    position: absolute;
    right: ${(props) => (props.hasPlayedInIos ? '40px' : 0)};
    top: 0;
  }

  & > div.player > video {
    display: inline-block;
    width: 100%;
    background-color: rgba(128, 128, 128, 0.5);
  }

  video::-webkit-media-controls-mute-button {
    display: none !important;
  }

  & > div.player {
    position: relative;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    line-height: 0;
  }

  & > div.player > div.download-button {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 44px;
    height: 44px;
    border-top-left-radius: 8px;
    background: rgba(0, 0, 0, 0.3);
    background-image: url(${DownloadIcon}); /* Update the path to your image */
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.5;
  }
`;

function PostContentVideo({ paragraph }: PostContentVideoPropsT) {
  const handleClick = () => {
    // 다운로드를 위한 링크
    const baseUrl = `${Config.fileServerBaseUrl}${Config.contentVideoPathPrefix}`;

    const url = `${baseUrl}${paragraph.path}`;

    interfaceBridge.downloadFile(
      url,
      paragraph.fileName || 'noVideoName',
      'video',
    );
  };

  // Detect if the device is iOS
  const md = new MobileDetect(window.navigator.userAgent);
  const isIOS = md.is('iOS');

  // State to track if video has played on iOS
  const [hasPlayedInIos, setHasPlayedInIos] = useState(false);

  const handlePlay = () => {
    if (isIOS) {
      setHasPlayedInIos(true);
    }
  };

  const baseUrl = `${Config.fileServerBaseUrl}${Config.contentVideoPathPrefix}`;
  const posterBaseUrl = `${Config.fileServerBaseUrl}${Config.contentVideoThumbnailPathPrefix}`;

  const handleContextMenu = (e) => {
    e.preventDefault();
    console.log('User tried to access the video context menu');
  };

  return (
    <StyledVideoParagraph hasPlayedInIos={hasPlayedInIos}>
      <div className="player">
        <video
          controls
          controlsList="nodownload noplaybackrate"
          poster={`${posterBaseUrl}${paragraph.path}`}
          preload="metadata"
          onContextMenu={handleContextMenu}
          onPlay={handlePlay}
        >
          <source src={`${baseUrl}${paragraph.path}`} />
        </video>
      </div>
      <div className="download-button-placer">
        <IconButton onClick={handleClick} sx={{ pt: '4px' }}>
          <FileDownloadOutlinedIcon />
        </IconButton>
      </div>
    </StyledVideoParagraph>
  );
}
export default PostContentVideo;
